/* eslint-disable */
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import MainCard from 'components/MainCard';
import { useTheme } from '@mui/material/styles';
// import moment from "moment";
import { Box } from '@mui/material';
import comptroller from 'assets/images/comptroller_white.svg';
import React, { useEffect, useState } from 'react';
import { Button, Col, DatePicker, Flex, Form, Row, Spin, TimePicker } from 'antd';
import DetailPageHeader from 'components/header/DetailPageHeader';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import { useAttendanceMutation } from 'store/features/menu/menuApi';
import { formatDateToUTC } from 'utils/utils';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';

function ManualAttendance() {
	const theme = useTheme();
	const [form] = Form.useForm();

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();

	// const [attendance, { error: errorData, isSuccess: isAttendanceSuccess, isLoading: isAttendanceLoading, isError: isAttendanceError }] =
	// 	useAttendanceMutation();

	const [sendControlData, { error: errorData, isSuccess: isAttendanceSuccess, isLoading: isAttendanceLoading, isError: isAttendanceError }] =
		useSendControlDataMutation();

	const onSubmitHandler = (payload) => {
		// console.log("payload", payload);
		setSubmitData(payload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		const entryDateISOLocal = formatDateToUTC(submitData?.entryDate) ?? '';
		const entryDate = entryDateISOLocal?.split('T')[0];
		// const entryTime = submitData?.entryTime.toISOString().split("T")[1];
		// const exitTime = submitData?.exitTime.toISOString().split("T")[1];

		// const adjustISO6HourForDate = (entryTime, entryDate) => {
		//   const utcDate = new Date(entryTime);

		//   const date = new Date(entryDate);
		//   if (utcDate.getUTCHours() >= 12 && utcDate.getUTCMinutes() < 60) {
		//     date.setDate(date.getDate() - 1);
		//     return date.toISOString().split("T")[0];
		//   } else {
		//     return date.toISOString().split("T")[0];
		//   }
		// };
		const payload = {
			entryDate: entryDate,
			entryTime: submitData?.entryTime,
			exitTime: submitData?.exitTime,
		};

		const convertJson = JSON.stringify(payload);
		const convertBase64 = btoa(convertJson);

		sendControlData({
			data: convertBase64,
			payload: payload,
			processCode: 'attendance',
			scriptName: 'record',
		});
	};

	useEffect(() => {
		if (isAttendanceSuccess) {
			toast.success('Action Completed Successfully', toastConfig);
			form.resetFields();
		} else if (isAttendanceError) {
			toast.error('Failed! Action not completed', toastConfig);
		}
	}, [isAttendanceSuccess, isAttendanceError, errorData]);

	//   useEffect(() => {
	//     if (isEmpty(state?.processCode)) {
	//       navigate(-1);
	//     }
	//   }, [state?.processCode]);

	return (
		<Box>
			<DetailPageHeader title="Manual Attendance Entry" />

			<Spin spinning={isAttendanceLoading} style={{ maxHeight: '100%' }}>
				<MainCard>
					<Form
						form={form}
						id="attendance-shift-create"
						layout="vertical"
						// initialValues={}
						requiredMark={false}
						onFinish={onSubmitHandler}
						autoComplete="off"
					>
						<AntdValuePreview form={form} show={true} />
						<Row gutter={[16, 0]}>
							<Col xs={24}>
								<Form.Item
									label="Date"
									name="entryDate"
									rules={[
										{
											required: true,
											message: 'Date Field is required',
										},
									]}
								>
									<DatePicker style={{ width: '100%' }} />
								</Form.Item>
							</Col>
							<Col xs={12}>
								<Form.Item
									label="Entry Time"
									name="entryTime"
									rules={[
										{
											required: true,
											message: 'Entry Time is required',
										},
									]}
								>
									<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} placeholder="Select entry time" />
								</Form.Item>
							</Col>
							<Col xs={12}>
								<Form.Item
									label="Exit Time"
									name="exitTime"
									rules={[
										{
											required: true,
											message: 'Exit Time is required',
										},
									]}
								>
									<TimePicker use12Hours format="h:mm a" style={{ width: '100%' }} placeholder="Select exit time" />
								</Form.Item>
							</Col>
							<Col xs={24}>
								<Flex justify="end">
									<Button
										className="animated-button"
										type="primary"
										htmlType="submit"
										style={{ backgroundColor: theme.palette.lynTheme.main }}
									>
										Submit
									</Button>
								</Flex>
							</Col>
						</Row>
					</Form>
				</MainCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					modalData={{
						head: 'Attendance',
						label: 'Do you want to proceed?',
					}}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</Box>
	);
}

export default ManualAttendance;
